import axios from "axios";
import OAuth from "../OAuth";
const { url } = OAuth;

const API = axios.create({ baseURL: url });

// Discord
export const DISCORD_HOOK_CONTACT = "https://discord.com/api/webhooks/890866187733463051/QKctBoy7vuEynZ4K-83QazENbtuWbWqFulfjDY_5-6sCoUge8k3H_mFnqu3G65notIN0";

// Login
export const GOOGLE_LOGIN = `${url}/api/v1/auth/google`;

export const FETCH_USER = `${url}/api/v1/auth/user`;
export const LOGOUT = `${url}/api/v1/auth/user/logout`;
export const UPDATE_PREFFERED_LANGUAGE = `${url}/api/v1/auth/user/updatePrefferedLanguage`;

export const SIGNUP = `${url}/api/v1/auth/signup`
export const SIGNIN = `${url}/api/v1/auth/signin`

// Budget
export const ADD_NEW_TRANSACTION = `${url}/api/v1/budget/addNew`;
export const FETCH_BUDGET = `${url}/api/v1/budget/getList`;
export const UPDATE_BUDGET = `${url}/api/v1/budget/update`;
export const DELETE_BUDGET = `${url}/api/v1/budget/delete`;
export const TOTAL_BUDGET_SUMMARIZE = `${url}/api/v1/budget/totalBudgetSummarize`;
export const CURRENCY_UPDATE =`${url}/api/v1/currency/update`;

export const GRAPH_DATA_PERIOD = `${url}/api/v1/budget/graphData`;
export const FILTERED_REPORT_LIST = `${url}/api/v1/budget/reportList`;

